import { BaseControl } from '.';
import DraggableNumberInput from '../components/DraggableNumberInput';

/** @typedef {import('../components/CssUnitSelect').CssUnit} CssUnit */

/**
 * @typedef {object} NumberCssControlOptions
 * @property {number} [min] - Minimum value
 * @property {number} [max] - Maximum value
 * @property {number} [step] - Step increment
 * @property {CssUnit[]} [units] - Optional list of allowed units (overrides options.units)
 */

/**
 * @typedef {object} NumberCssControlValue
 * @property {number | null} value - The numeric value with optional unit
 * @property {CssUnit} [unit] - Optional unit (e.g. 'px', 'em', '%', 'auto')
 */

/**
 * Convert a non-css value (number) to a css value + unit
 * @param {any} value 
 * @return {NumberCssControlValue}
 */
const backwardCompatCssValue = (value) => {
    if (value === undefined || value === null) {
        return { value: 0, unit: 'px' };
    }
    if (typeof value === 'number') {
        return { value: value, unit: 'px' };
    }
    return value;
};

/**
 * @extends {BaseControl<NumberCssControlValue, NumberCssControlOptions>}
 */
export class NumberCssControl extends BaseControl {

    /** @type {BaseControl<NumberCssControlValue>['render']} */
    render(value, onChange) {
        return (
            <label className="number-control">
                {this.label}
                <DraggableNumberInput
                    value={backwardCompatCssValue(value)?.value ?? this.defaultValue?.value ?? 0}
                    unit={backwardCompatCssValue(value)?.unit ?? this.defaultValue?.unit ?? 'px'}
                    onChange={(value, unit) => onChange({ value, unit })}
                    units={this.options?.units}
                    min={this.options?.min}
                    max={this.options?.max}
                    step={this.options?.step}
                />
            </label>
        );
    }
}
